import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaCode, FaReact, FaJs, FaNode, FaHtml5, FaCss3Alt, FaBootstrap, FaPython } from 'react-icons/fa';
import { SiMongodb, SiExpress, SiNextdotjs, SiTailwindcss, SiRedux, SiNestjs, SiVite } from 'react-icons/si';
import Navbar from '../components/Navbar';
import './ProjectTechnologies.css';

const ProjectTechnologies = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const projectIdNum = parseInt(projectId);

  // Technology icon mapping
  const techIcons = {
    'React': { icon: <FaReact />, color: '#61DAFB' },
    'JavaScript': { icon: <FaJs />, color: '#F7DF1E' },
    'Node.js': { icon: <FaNode />, color: '#339933' },
    'MongoDB': { icon: <SiMongodb />, color: '#47A248' },
    'Express': { icon: <SiExpress />, color: '#000000' },
    'Express.js': { icon: <SiExpress />, color: '#000000' },
    'HTML5': { icon: <FaHtml5 />, color: '#E34F26' },
    'CSS3': { icon: <FaCss3Alt />, color: '#1572B6' },
    'Bootstrap': { icon: <FaBootstrap />, color: '#7952B3' },
    'Next.js': { icon: <SiNextdotjs />, color: '#000000' },
    'Nest.js': { icon: <SiNestjs />, color: '#E0234E' },
    'Tailwind CSS': { icon: <SiTailwindcss />, color: '#06B6D4' },
    'Redux': { icon: <SiRedux />, color: '#764ABC' },
    'CSV Parser': { icon: <FaCode />, color: '#FFA500' },
    'Mongoose': { icon: <SiMongodb />, color: '#880000' },
    'Python': { icon: <FaPython />, color: '#3776AB' },
    'yt-dlp': { icon: <FaCode />, color: '#FF6B6B' },
    'pytube': { icon: <FaCode />, color: '#FF6B6B' },
    'Vite': { icon: <SiVite />, color: '#646CFF' }
  };

  // Project data - matching Projects.js structure
  const projects = [
    {
      id: 1,
      title: 'Daily Collection Management System',
      technologies: ['React', 'Node.js', 'MongoDB', 'Express']
    },
    {
      id: 2,
      title: 'SPEX ID Topup Random Sweep Giveaway',
      technologies: ['React', 'JavaScript', 'CSV Parser', 'Node.js']
    },
    {
      id: 3,
      title: 'City Pet Adoption Center Web Application',
      technologies: ['Nest.js', 'MongoDB', 'Tailwind CSS']
    },
    {
      id: 4,
      title: 'Receipt Printing System',
      technologies: ['Nest.js']
    },
    {
      id: 5,
      title: 'Spex ID Topup Center',
      technologies: ['React', 'Next.js', 'MongoDB']
    },
    {
      id: 6,
      title: 'Simple Signin Signup',
      technologies: ['React', 'Vite']
    }
  ];

  const project = projects.find(p => p.id === parseInt(projectId));

  useEffect(() => {
    if (!project) {
      navigate('/');
    }
  }, [project, navigate]);

  if (!project || !project.technologies) {
    return null;
  }

  return (
    <div className="project-technologies-page">
      <Navbar />
      <div className="project-technologies-container">
        <button 
          className="back-button"
          onClick={() => {
            navigate(-1);
          }}
        >
          <FaArrowLeft /> Back to Projects
        </button>

        <div className="project-technologies-content">
          <h1 className="project-technologies-title">Technologies Used</h1>
          <h2 className="project-name">{project.title}</h2>
          
          <div className="tech-icons-container">
            {project.technologies.map((tech, index) => {
              const techData = techIcons[tech] || { icon: <FaCode />, color: '#FFA500' };
              return (
                <motion.div
                  key={tech}
                  className="tech-icon-item"
                  initial={{ 
                    opacity: 0, 
                    scale: 0,
                    x: Math.random() * 200 - 100,
                    y: Math.random() * 200 - 100,
                    rotate: Math.random() * 360
                  }}
                  animate={{ 
                    opacity: 1, 
                    scale: 1,
                    x: 0,
                    y: 0,
                    rotate: 0
                  }}
                  transition={{ 
                    delay: index * 0.1,
                    type: "spring",
                    stiffness: 200,
                    damping: 15
                  }}
                  whileHover={{ scale: 1.15, rotate: 5 }}
                >
                  <div 
                    className="tech-icon-wrapper"
                    style={{ color: techData.color }}
                  >
                    {techData.icon}
                  </div>
                  <span className="tech-name">{tech}</span>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectTechnologies;

